var exports = {
  "Y": "Page__W6j-xz",
};

module.exports = exports;
